import backendURL from "./config";

export const login = async (email, password) => {
  const response = await backendURL.post("user/login", { email, password });
  return response.data.data;
};
export const forgetPassword = async (email) => {
  const response = await backendURL.post("user/forgotpassword", { email });
  return response.data.data;
};
export const changePassword = async (user_id, password, newpassword) => {
  const response = await backendURL.post("user/changepassword", {
    user_id,
    password,
    newpassword,
  });
  return response.data.data;
};
